module.exports = __webpack_public_path__ + "static/img/1901_9.a3b431f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1901_9.jpg
// module id = 4XwD
// module chunks = 1